// src/pages/EntouragePage.js
import React from 'react';
import Navbar from '../components/Navbar';
import { WEDDING_CONFIG } from '../config';
import Footer from '../components/Footer';

const EntouragePage = () => {
  return (
    <div style={styles.page}>
      <Navbar />

      {/* Fixed Background Image - ONLY shows for glass sections */}
      <div style={styles.backgroundImage}></div>
      
      {/* Hero Section */}
      <section style={styles.hero}>
        <h1 style={styles.heroTitle}>The Entourage</h1>
        <p style={styles.heroSubtitle}>Those who will witness our special day</p>
      </section>

      {/* Main Content */}
      <section style={styles.section}>
        <div style={styles.container}>

          {/* Couple Names */}
          <section style={styles.section}>
          <div style={styles.glassCard}>
          <div style={styles.coupleSection}>
            <h2 style={styles.coupleTitle}>Balleta - Ereño</h2>
            <p style={styles.coupleSubtitle}>NUPTIALS</p>
            </div>
          </div>
          </section>

          {/* Parents */}
          <section style={styles.section}>
          <div style={styles.glassCard}>
              <div style={styles.parentColumn}>
                <h3 style={styles.sectionHeading}>Parents of the Groom</h3>
                <p style={styles.name}>Mr. Gregorio R. Balleta, Sr.</p>
                <p style={styles.name}>Mrs. Evelyn M. Balleta</p>
              </div>
              <div style={styles.parentColumn}>
                <h3 style={styles.sectionHeading}>Parents of the Bride</h3>
                <p style={styles.name}>Mr. Pio P. Ereño</p>
                <p style={styles.name}>Mrs. Sanny E. Ereño</p>
              </div>
            </div>
      </section>

{/* Principal Sponsors */}
<section style={styles.section}>
  <div style={styles.glassCard}>
  <h3 style={styles.mainHeading}>Principal Sponsors</h3>
  <p style={styles.subtitle}>TO STAND AS WITNESS TO OUR VOWS</p>
  
  <div style={styles.sponsorPairGrid} className="sponsor-pair-grid">
    <div style={styles.sponsorPair}>
      <p style={styles.sponsorName}>Ms. Marilee Abata - Cinco</p>
      <p style={styles.sponsorDash}>-</p>
      <p style={styles.sponsorName}>Engr. Andy S. Ereño</p>
    </div>

   <div style={styles.sponsorPair}>
      <p style={styles.sponsorName}>PCPT. Solomon A. Agayso</p>
      <p style={styles.sponsorDash}>-</p>
      <p style={styles.sponsorName}>Mrs. Jinky C. Montaño</p>
    </div>
    
    <div style={styles.sponsorPair}>
      <p style={styles.sponsorName}>Dr. Ana Marnie Julie T. Layon</p>
      <p style={styles.sponsorDash}>-</p>
      <p style={styles.sponsorName}>Dr. Gilbert F. Layon</p>
    </div>
    
    <div style={styles.sponsorPair}>
      <p style={styles.sponsorName}>Mrs. Cecilia C. Sancio</p>
      <p style={styles.sponsorDash}>-</p>
      <p style={styles.sponsorName}>Engr. Alvin A. Ignacio</p>
    </div>
    
    <div style={styles.sponsorPair}>
      <p style={styles.sponsorName}>Mrs. Evangeline T. Entico</p>
      <p style={styles.sponsorDash}>-</p>
      <p style={styles.sponsorName}>Mr. Ruben S. Entico</p>
    </div>
    
    <div style={styles.sponsorPair}>
      <p style={styles.sponsorName}>Mrs. Leah P. Genio</p>
      <p style={styles.sponsorDash}>-</p>
      <p style={styles.sponsorName}>Hon. Fiel B. Genio</p>
    </div>
    
    <div style={styles.sponsorPair}>
      <p style={styles.sponsorName}>Mrs. Betty V. Portajada</p>
      <p style={styles.sponsorDash}>-</p>
      <p style={styles.sponsorName}>Dr. Amador C. Portajada, Jr.</p>
    </div>
    
    <div style={styles.sponsorPair}>
      <p style={styles.sponsorName}>Mrs. Ana Liza H. Pomida</p>
      <p style={styles.sponsorDash}>-</p>
      <p style={styles.sponsorName}>Engr. Gil E. De Silva</p>
    </div>
    
    <div style={styles.sponsorPair}>
      <p style={styles.sponsorName}>Mrs. Precy M. Ereño</p>
      <p style={styles.sponsorDash}>-</p>
      <p style={styles.sponsorName}>Engr. Francisco M. Ereño, Jr.</p>
    </div>
    
    <div style={styles.sponsorPair}>
      <p style={styles.sponsorName}>Mrs. Letecia P. Lucban</p>
      <p style={styles.sponsorDash}>-</p>
      <p style={styles.sponsorName}>Mr. Christopher B. Clemens</p>
    </div>
    
    <div style={styles.sponsorPair}>
      <p style={styles.sponsorName}>Engr. Lani G. Aticaldo</p>
      <p style={styles.sponsorDash}>-</p>
      <p style={styles.sponsorName}>Mr. Ernesto Cagsawa</p>
    </div>
    
    <div style={styles.sponsorPair}>
      <p style={styles.sponsorName}>Engr. Corona Daryl G. Uy</p>
      <p style={styles.sponsorDash}>-</p>
      <p style={styles.sponsorName}>Mr. Vicente B. Arillo, Jr.</p>
    </div>
    
    <div style={styles.sponsorPair}>
      <p style={styles.sponsorName}>Ms. Joy C. Alcera</p>
      <p style={styles.sponsorDash}>-</p>
      <p style={styles.sponsorName}>Mr. Brenfred N. Romero</p>
    </div>
    
    <div style={styles.sponsorPair}>
      <p style={styles.sponsorName}>Mrs. Jennifer B. Tan</p>
      <p style={styles.sponsorDash}>-</p>
      <p style={styles.sponsorName}>Mr. Peter John Z. Tan</p>
    </div>
    
    <div style={styles.sponsorPair}>
      <p style={styles.sponsorName}>Mrs. Imelda G. Salundaguit</p>
      <p style={styles.sponsorDash}>-</p>
      <p style={styles.sponsorName}>Mr. Guadioso Agus</p>
    </div>
    
    <div style={styles.sponsorPair}>
      <p style={styles.sponsorName}>Mrs. Amelia B. Lytle</p>
      <p style={styles.sponsorDash}>-</p>
      <p style={styles.sponsorName}>Hon. Manuel Cuyco, Jr.</p>
    </div>
    
    <div style={styles.sponsorPair}>
      <p style={styles.sponsorName}>Mrs. Len A. Miranda</p>
      <p style={styles.sponsorDash}>-</p>
      <p style={styles.sponsorName}>Mr. Bryan Jay B. Balleta</p>
    </div>
    
    <div style={styles.sponsorPair}>
      <p style={styles.sponsorName}>Mrs. Tara O. Calixtro</p>
      <p style={styles.sponsorDash}>-</p>
      <p style={styles.sponsorName}>Dr. Elmer P. Calixtro</p>
    </div>
    
    <div style={styles.sponsorPair}>
      <p style={styles.sponsorName}>Mrs. Exaltacion C. Aguilando</p>
      <p style={styles.sponsorDash}>-</p>
      <p style={styles.sponsorName}>Mr. Pedro Destura, Jr.</p>
    </div>
    
    <div style={styles.sponsorPair}>
      <p style={styles.sponsorName}>Mrs. Carol B. Amar</p>
      <p style={styles.sponsorDash}>-</p>
      <p style={styles.sponsorName}>Mr. Dennis B. Dalucapas</p>
    </div>
    
    <div style={styles.sponsorPair}>
      <p style={styles.sponsorName}>Mrs. Aileen Agura</p>
      <p style={styles.sponsorDash}>-</p>
      <p style={styles.sponsorName}>PLT. Vic T. Camposano</p>
    </div>
    
    <div style={styles.sponsorPair}>
      <p style={styles.sponsorName}>Mrs. Dhina E. Forbes</p>
      <p style={styles.sponsorDash}>-</p>
      <p style={styles.sponsorName}>Mr. Roy A. Cinco</p>
    </div>
    
    <div style={styles.sponsorPair}>
      <p style={styles.sponsorName}>Mrs. Rosario S. Rebamonte</p>
      <p style={styles.sponsorDash}>-</p>
      <p style={styles.sponsorName}>Mr. Danilo E. Infante</p>
    </div>
    
    <div style={styles.sponsorPair}>
      <p style={styles.sponsorName}>Mrs. Maricar S. De Asas</p>
      <p style={styles.sponsorDash}>-</p>
      <p style={styles.sponsorName}>Mr. Joel E. Jacala</p>
    </div>
    
    <div style={styles.sponsorPair}>
      <p style={styles.sponsorName}>Mrs. Rebecca N. Pederio</p>
      <p style={styles.sponsorDash}>-</p>
      <p style={styles.sponsorName}>Mr. Rogelio Cajandab</p>
    </div>
    
    <div style={styles.sponsorPair}>
      <p style={styles.sponsorName}>Dr. Narlita B. Rafon</p>
      <p style={styles.sponsorDash}>-</p>
      <p style={styles.sponsorName}>Ret. Police Francisco Pestaño, Jr.</p>
    </div>
    
    <div style={styles.sponsorPair}>
      <p style={styles.sponsorName}>Mrs. Vanessa D. Pestaño</p>
      <p style={styles.sponsorDash}>-</p>
      <p style={styles.sponsorName}>Mr. Alvin T. Pestaño</p>
    </div>
  </div>
</div>
</section>

          {/* Best Man & Matron/Maid of Honor - Cards in Row */}
      <section style={styles.section}>
        <div style={styles.glassCard}>
            <div style={styles.honorGrid} className="honor-grid">
              <div style={styles.honorBox}>
                <h3 style={styles.honorTitle}>Best Man</h3>
                <p style={styles.honorName}>Engr. Gregorio M. Balleta, Jr.</p>
              </div>
              <div style={styles.honorBox}>
                <h3 style={styles.honorTitle}>Matron of Honor</h3>
                <p style={styles.honorName}>Mrs. Mariz E. Brogada</p>
              </div>
              <div style={styles.honorBox}>
                <h3 style={styles.honorTitle}>Maid of Honor</h3>
                <p style={styles.honorName}>Engr. Maria Gladys S. Jarito</p>
              </div>
            </div>
           </div> 
          </section>

          {/* Candle, Veil, Cord - Cards in Row */}
          <section style={styles.section}>
          <div style={styles.glassCard}>
            <div style={styles.symbolGrid} className="symbol-grid">
              <div style={styles.symbolBox}>
                <h3 style={styles.symbolTitle}>Candle</h3>
                <p style={styles.symbolSubtitle}>TO LIGHT OUR PATH</p>
                <p style={styles.name}>SFO1. Mark Leo M. Balleta</p>
                <p style={styles.name}>Mrs. Geraldine D. Balleta</p>
              </div>
              <div style={styles.symbolBox}>
                <h3 style={styles.symbolTitle}>Veil</h3>
                <p style={styles.symbolSubtitle}>TO CLOTHE US AS ONE</p>
                <p style={styles.name}>Mr. Mark Dave E. Ereño</p>
                <p style={styles.name}>Mrs. Erika P. Ereño</p>
              </div>
              <div style={styles.symbolBox}>
                <h3 style={styles.symbolTitle}>Cord</h3>
                <p style={styles.symbolSubtitle}>TO BIND US TOGETHER</p>
                <p style={styles.name}>Mr. Rogelio E. Canlas</p>
                <p style={styles.name}>Mrs. Mary Ann E. Canlas</p>
              </div>
            </div>
          </div>
        </section>

          {/* Bridesmaids and Groomsmen */}
        <section style={styles.section}>
          <div style={styles.glassCard}>
            <h3 style={styles.mainHeading}>TO LEAD US IN OUR WAY</h3>
            <div style={styles.bridalPartyGrid} className="bridal-party-grid">
              <div style={styles.bridalColumn}>
                <h4 style={styles.subHeading}>Bridesmaids</h4>
                <p style={styles.name}>Engr. Danilyn L. Fraga</p>
                <p style={styles.name}>Ms. Mithe F. Calipay</p>
                <p style={styles.name}>Mrs. Madonna B. Masayon</p>
                <p style={styles.name}>Ms. Mica E. Alcera</p>
                <p style={styles.name}>Engr. Nathalie Joy E. Etac</p>
                <p style={styles.name}>Ms. Cherry N. Turla</p>
                <p style={styles.name}>Ms. Alyka S. De Asas</p>
                <p style={styles.name}>Ms. Moira Mae M. Deguiño</p>
                <p style={styles.name}>Engr. Aurifel P. Lucban</p>
                <p style={styles.name}>Ms. Joy Ann B. Capawing</p>
                <p style={styles.name}>Ms. Tricia Ann M. Bido</p>
                <p style={styles.name}>Ms. Edelyn M. Miranda</p>
                <p style={styles.name}>Mrs Realyn C. Casulla</p>
                <p style={styles.name}>Ms. Anna Grace A. Sarzata</p>

              </div>
              <div style={styles.bridalColumn}>
                <h4 style={styles.subHeading}>Groomsmen</h4>
                <p style={styles.name}>Mr. Reden L. Pestaño</p>
                <p style={styles.name}>Mr. Menard M. Deguiño</p>
                <p style={styles.name}>Mr. Jerome Masayon</p>
                <p style={styles.name}>Mr. Robert James B. Fortaleza</p>
                <p style={styles.name}>Mr. John Rex V. Ultra</p>
                <p style={styles.name}>Mr. Jomar G. Salundaguit</p>
                <p style={styles.name}>Mr. Daven Brix E. Ereño</p>
                <p style={styles.name}>Mr. John Piolo E. Ereño</p>
                <p style={styles.name}>Mr. Nhiel Bryan E. E. Ereño</p>
                <p style={styles.name}>Mr. Emmanuel S. Gamao</p>
                <p style={styles.name}>Mr. Brent John B. Tan</p>
                <p style={styles.name}>Mr. Manuel B. Bocabo</p>
                <p style={styles.name}>Mr. Salvador S. Casulla Jr.</p>
                <p style={styles.name}>Mr. Lemuel Albert M. Aquino</p>

              </div>
            </div>
          </div>
        </section>
          {/* Bearers - Cards in Row */}
         <section style={styles.section}>
          <div style={styles.glassCard}>
            <div style={styles.bearerGrid} className="bearer-grid">
              <div style={styles.bearerBox}>
                <h3 style={styles.symbolTitle}>Coin Bearer</h3>
                <p style={styles.symbolSubtitle}>TO CARRY THE SYMBOL OF PROSPERITY</p>
                <p style={styles.name}>Elijah Maben D. Estillero</p>
              </div>
              <div style={styles.bearerBox}>
                <h3 style={styles.symbolTitle}>Bible Bearer</h3>
                <p style={styles.symbolSubtitle}>TO CARRY THE SYMBOL OF FAITH</p>
                <p style={styles.name}>Marius Cyril E. Brogada</p>
              </div>
              <div style={styles.bearerBox}>
                <h3 style={styles.symbolTitle}>Ring Bearer</h3>
                <p style={styles.symbolSubtitle}>TO CARRY THE SYMBOL OF ETERNAL LOVE</p>
                <p style={styles.name}>Maddox Elliot P. Ereño</p>
              </div>
            </div>
          </div>
        </section>

          {/* Little Bridal Party */}
         <section style={styles.section}>
          <div style={styles.glassCard}>
            <h3 style={styles.mainHeading}>Little Bridesmaid and Little Groomsmen</h3>
            <div style={styles.littleBridalGrid} className="little-bridal-grid">
              <div style={styles.littleColumn}>
                <p style={styles.name}>Dorothy Fleur M. Mueva</p>
                <p style={styles.name}>Atasha Marie P. Morales</p>
                <p style={styles.name}>Arya Jaline S. Miano</p>
                <p style={styles.name}>Euggie R. Senobio</p>
                <p style={styles.name}>Krezel Jen A. Acibar</p>
                <p style={styles.name}>Mary Treah E. Canlas</p>
              </div>
              <div style={styles.littleColumn}>
                <p style={styles.name}>Marco Antonio A. Balbosa</p>
                <p style={styles.name}>Zion Doncic L. Tepace </p>
                <p style={styles.name}>Giede Ayden A. Gamorot</p>
                <p style={styles.name}>Queniel Matteo L. Paghunasan</p>
                <p style={styles.name}>Kyle Florenfil M. Sandoval</p>
              </div>
            </div>
          </div>
        </section>

          {/* Brides Banner */}
          <section style={styles.section}>
          <div style={styles.glassCard}>
            <h3 style={styles.symbolTitle}>Brides Banner</h3>
            <div style={styles.bannerContent}>
              <p style={styles.name}>Mavyz Qyn D. Azul</p>
              <p style={styles.name}>Acezyn Deguiño</p>
            </div>
          </div>
        </section>

        </div>
      </section>
              {/* ADD FOOTER HERE */}
        <Footer />
    </div>
  );
};

const styles = {
  page: {
    position: 'relative',
    minHeight: '100vh',
  },
    // Background Image - Only visible in glass sections (hidden behind hero gradient)
    backgroundImage: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundImage: `url(${WEDDING_CONFIG.images.entourage})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
      backgroundRepeat: 'no-repeat',
      zIndex: -1,
    },
  hero: {
    height: '100vh',
    background: `linear-gradient(135deg, ${WEDDING_CONFIG.colors.primary}, ${WEDDING_CONFIG.colors.secondary})`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    textAlign: 'center',
    marginTop: '60px',
    padding: '2rem',
  },
  heroTitle: {
    fontSize: '4rem',
    fontFamily: "'Great Vibes', 'Playfair Display', serif",
    marginBottom: '1rem',
  },
  heroSubtitle: {
    fontSize: '1.3rem',
    fontWeight: '300',
  },
  section: {
    padding: '4rem 2rem',
  },
    // Frosted Glass Card Effect
    glassCard: {
    background: 'rgba(255, 255, 255, 0.15)',
    backdropFilter: 'blur(0.5px)',
    WebkitBackdropFilter: 'blur(0.5px)',
    borderRadius: '30px',
    padding: '2rem',
    border: '1px solid rgba(255, 255, 255, 0.3)',
    boxShadow: '0 16  px 64px rgba(0, 0, 0, 0.1)',
    maxWidth: '800px',
    width: '100%',
    margin: '0 auto',
    boxSizing: 'border-box',
  },
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
  },
  contentCard: {
    background: 'white',
    padding: '3rem',
    borderRadius: '20px',
    boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
    marginBottom: '3rem',
  },
  coupleSection: {
    textAlign: 'center',
    marginBottom: '4rem',
  },
  coupleTitle: {
    fontSize: '3rem',
    fontFamily: "'Great Vibes', 'Playfair Display', serif",
    color:'rgba(255, 255, 255, 0.9)',
    fontStyle: 'italic',
    marginBottom: '0.5rem',
  },
  coupleSubtitle: {
    fontSize: '1.2rem',
    letterSpacing: '3px',
    color: 'rgba(255, 255, 255, 0.9)',
    fontWeight: '600',
  },
  parentsGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '3rem',
  },
  parentColumn: {
    textAlign: 'center',
  },
  sectionHeading: {
    fontSize: '1.8rem',
    fontFamily: "'Playfair Display', cursive",
    color:'rgba(255, 255, 255, 0.9)',
    marginBottom: '1.5rem',
    fontStyle: 'italic',
  },
  mainHeading: {
    fontSize: '2.5rem',
    fontFamily: "'Playfair Display', serif",
    color:'rgba(255, 255, 255, 0.9)',
    textAlign: 'center',
    marginBottom: '1rem',
  },
  subtitle: {
    fontSize: '0.9rem',
    letterSpacing: '2px',
    textTransform: 'uppercase',
    color: 'rgba(255, 255, 255, 0.9)',
    textAlign: 'center',
    marginBottom: '2rem',
    fontWeight: '600',
  },
  sponsorPairGrid: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2rem',
    marginTop: '2rem',
    minWidth: '200px',
  },
  sponsorPair: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '1.5rem',
    padding: '1rem',
    background: `${WEDDING_CONFIG.colors.light}30`,
    borderRadius: '10px',
    flexWrap: 'wrap',
  },
  sponsorName: {
    fontSize: '1rem',
    color: 'rgba(255, 255, 255, 0.9)',
    margin: 0,
    flex: '1',
    minWidth: '200px',
    textAlign: 'center',
  },
  sponsorDash: {
    fontSize: '1.2rem',
    color: 'rgba(255, 255, 255, 0.9)',
    fontWeight: '600',
    margin: 0,
  },

  sponsorColumn: {
    textAlign: 'center',
  },
  name: {
    fontSize: '1rem',
    color: 'rgba(255, 255, 255, 0.9)',
    marginBottom: '0.5rem',
    lineHeight: '1.6',
  },
  honorGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '2rem',
  },
  honorBox: {
    textAlign: 'center',
    padding: '1.5rem',
    background: `${WEDDING_CONFIG.colors.light}30`,
    borderRadius: '15px',
  },
  honorTitle: {
    fontSize: '1.8rem',
    fontFamily: "'Playfair Display', cursive",
    color: 'rgba(255, 255, 255, 0.9)',
    marginBottom: '1rem',
    fontStyle: 'italic',
  },
  honorName: {
    fontSize: '1rem',
    color: 'rgba(255, 255, 255, 0.9)',
    lineHeight: '1.6',
  },
  symbolGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '2rem',
  },
  symbolBox: {
    textAlign: 'center',
    padding: '1.5rem',
    background: `${WEDDING_CONFIG.colors.light}30`,
    borderRadius: '15px',
  },
  symbolTitle: {
    fontSize: '2rem',
    fontFamily: "'Playfair Display', cursive",
    color: 'rgba(255, 255, 255, 0.9)',
    marginBottom: '0.5rem',
    fontStyle: 'italic',
  },
  symbolSubtitle: {
    fontSize: '0.8rem',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    color: 'rgba(255, 255, 255, 0.9)',
    marginBottom: '1.5rem',
  },
  bridalPartyGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '3rem',
    marginTop: '2rem',
  },
  bridalColumn: {
    textAlign: 'center',
  },
  subHeading: {
    fontSize: '1.5rem',
    fontFamily: "'Playfair Display', cursive",
    color: 'rgba(255, 255, 255, 0.9)',
    marginBottom: '1.5rem',
    fontStyle: 'italic',
  },
  bearerGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '2rem',
  },
  bearerBox: {
    textAlign: 'center',
    padding: '1.5rem',
    background: `${WEDDING_CONFIG.colors.light}30`,
    borderRadius: '15px',
  },
  littleBridalGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '3rem',
    marginTop: '2rem',
  },
  littleColumn: {
    textAlign: 'center',
  },
  bannerContent: {
    textAlign: 'center',
    marginTop: '1rem',
  },
};

export default EntouragePage;